import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { SpinnerTypes } from 'constants/Constants';
import { Label } from 'components/layout/Typography/Typography';

import styles from './SolidSpinner.module.scss';

const s = classNames.bind(styles);

const SolidSpinner = ({ className, color = SpinnerTypes.BLUE, size, label, labelClassName, absoluteCenter }) => (
	<div
		className={s('container', {
			container_absoluteCenter: absoluteCenter,
			[className]: className
		})}
	>
		<div>
			{label && (
				<Label className={labelClassName} marginTop={'1'} marginBottom={'2'} htmlFor={'Spinner'}>
					{label}
				</Label>
			)}
			<figure
				name={'Spinner'}
				className={s('spinner', {
					spinner_blue: color === SpinnerTypes.BLUE,
					spinner_grey: color === SpinnerTypes.GREY,
					spinner_white: color === SpinnerTypes.WHITE,
					spinner_small: size === SpinnerTypes.SMALL,
					spinner_medium: size === SpinnerTypes.MEDIUM,
					spinner_large: size === SpinnerTypes.LARGE
				})}
			/>
		</div>
	</div>
);

SolidSpinner.propTypes = {
	className: PropTypes.string,
	labelClassName: PropTypes.string,
	label: PropTypes.string,
	color: PropTypes.string,
	absoluteCenter: PropTypes.bool,
	size: PropTypes.string
};

export default SolidSpinner;
